import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestAddDocumentSource (action) {
  const { name, identifier, args, onSuccess, onFail } = action.payload

  try {
    yield call(apiAction, 'AddDocumentsSource', {
      name,
      identifier,
      args
    })

    onSuccess()
  } catch (error) {
    onFail(error)

    if (
      error.code !== 300
    ) {
      throw error
    }
  }
}
